import { DataType } from "@cloudpivot/form/typings";
import { inputControlOptions, TextAreaType } from "@cloudpivot/form/component-schema";
export default {
    $id: "aiPolish",
    type: DataType.Object,
    $ref: inputControlOptions.$id,
    properties: {
        defaultValue: {
            type: DataType.String,
            title: "默认值",
        },
        textAreaType: {
            type: DataType.String,
            title: "输入框样式",
            default: TextAreaType.LongText,
        },
        maxLength: {
            type: DataType.Integer,
            title: "最大长度",
            default: 2000,
        },
        currentMaxLength: {
            type: DataType.Integer,
            title: "字数限制",
            default: 2000,
        },
        placeholder: {
            type: DataType.String,
            title: "提示文字",
            default: "AI 润色后的内容将显示于此",
        },
        description: {
            type: DataType.String,
            title: "角色设定（系统描述）",
            default: "你是一名专业的文本润色助手。请在保持原意的前提下，将用户提供的文本润色得更专业、清晰、通顺，直接输出润色后的文本，不要添加任何解释或前缀。",
        },
        prompt: {
            type: DataType.String,
            title: "润色提示词",
            default: "请在保持原意的前提下，将以下内容润色得更专业、清晰、易于评审理解。",
        },
        temperature: {
            type: DataType.Number,
            title: "采样温度（0~2，留空使用服务端默认）",
        },
        maxTokens: {
            type: DataType.Integer,
            title: "最大输出 token 数（留空使用服务端默认）",
        }
    },
};
